
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/KoiFishCafe",
      function () {
        return require("private-next-pages/KoiFishCafe/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/KoiFishCafe"])
      });
    }
  